/**
 * Property keys whose `=` operator uses Cloudscape's `tokenType:
 * "enum"` — the property renders a multi-select checkbox popover
 * with Cancel/Apply, and the Polaris token value is `string[]`.
 * `PropertyFilterInput` uses this set to bridge between the array
 * shape Polaris emits and the scalar-per-`PropertyFilter` shape the
 * rest of the app (query builder, URL round-trip) expects.
 *
 * Kept in its own module (no Polaris imports) so parser code and
 * unit tests can consume it without pulling in Cloudscape.
 */
export const MULTISELECT_PROPERTY_KEYS: ReadonlySet<string> = new Set([
  "country",
  "asinParty",
  "asinType",
]);
